import URL from '../api_url';

export const SESSION_BEHAVIOR_API = `${URL}/behavior-session`;

export const SESSION_BEHAVIORS_API = `${URL}/behavior-sessions`;
